var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSolid3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 28,
    viewBox: "0 0 51 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.75 14C40.6065 14 42.387 13.2625 43.6997 11.9497C45.0125 10.637 45.75 8.85652 45.75 7C45.75 5.14348 45.0125 3.36301 43.6997 2.05025C42.387 0.737498 40.6065 0 38.75 0C36.8935 0 35.113 0.737498 33.8003 2.05025C32.4875 3.36301 31.75 5.14348 31.75 7C31.75 8.85652 32.4875 10.637 33.8003 11.9497C35.113 13.2625 36.8935 14 38.75 14ZM36.2508 16.625C30.8641 16.625 26.5 20.9891 26.5 26.3758C26.5 27.2727 27.2273 28 28.1242 28H49.3758C50.2727 28 51 27.2727 51 26.3758C51 20.9891 46.6359 16.625 41.2492 16.625H36.2508Z",
    fill: "#AA182C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_148_14941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14C14.1065 14 15.887 13.2625 17.1997 11.9497C18.5125 10.637 19.25 8.85652 19.25 7C19.25 5.14348 18.5125 3.36301 17.1997 2.05025C15.887 0.737498 14.1065 0 12.25 0C10.3935 0 8.61301 0.737498 7.30025 2.05025C5.9875 3.36301 5.25 5.14348 5.25 7C5.25 8.85652 5.9875 10.637 7.30025 11.9497C8.61301 13.2625 10.3935 14 12.25 14ZM9.75078 16.625C4.36406 16.625 0 20.9891 0 26.3758C0 27.2727 0.727344 28 1.62422 28H22.8758C23.7727 28 24.5 27.2727 24.5 26.3758C24.5 20.9891 20.1359 16.625 14.7492 16.625H9.75078Z",
    fill: "#AA182C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 28,
    fill: "white",
    transform: "translate(26.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_148_14941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolid3);
export default __webpack_public_path__ + "static/media/user-solid-3.500acdb8688388bafb76e8b7edc33d8e.svg";
export { ForwardRef as ReactComponent };